import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Podcast } from 'src/models/podcast';
import { Stream } from 'src/models/stream';
import { Genre } from 'src/models/genre';
import { Country } from 'src/models/country';
import { Episode } from 'src/models/episode';
import { EpisodeSearchResult } from 'src/models/episode-search-result';
import { PodcastSearchResult } from 'src/models/podcast-search-result';

@Injectable({
  providedIn: 'root'
})
export class PodcastService {

  private apiURL = '/main/podcast';

  constructor(private httpClient: HttpClient) { }

  public getGenres(): Observable<Genre[]> {
    return this.httpClient.get<object>(`${this.apiURL}/genres`).pipe(map(res => {

      const result = new Array<Genre>();

      const resPodcasts: Array<object> = JSON.parse(res['params']).genres;

      resPodcasts.forEach((item: object) => {
          const category = new Genre();

          category.id = item['id'];
          category.name = item['name'];

          result.push(category);
      });

      const sortedResult: Genre[] = result.sort((n1,n2) => {
          if (n1.name > n2.name) {
              return 1;
          }

          if (n1.name < n2.name) {
              return -1;
          }

          return 0;
      });

      return sortedResult;
    }));
  }

  public getCountries(): Observable<Country[]> {
    return this.httpClient.get<object>(`${this.apiURL}/countries`).pipe(map(res => {

      const result = new Array<Country>();

      const resPodcasts: object = JSON.parse(res['params']).regions;

      for ( const [key, value] of Object.entries( resPodcasts ) ) {
        console.log('key value: ', key, value);

        const country = new Country();

        country.id = key;
        country.name = value;

        result.push(country);
      }

      /*resPodcasts.forEach((item: object) => {
          const country = new Country();

          country.id = item['id'];
          category.name = item['name'];

          result.push(category);
      });

      return result;

      console.log('countries', res);*/
      return result;
    }));
  }

  public getTopGermanPodcasts(page: number): Observable<Stream[]> {

    return this.httpClient.post<object>((`${this.apiURL}/topGermanPodcasts`), {
      'page': page
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resPodcasts: Array<object> = JSON.parse(res['params']).podcasts;

      resPodcasts.forEach((item: object) => {
          result.push(Stream.fromPodcastResponseData(item));
      });

      return result;
    }));
  }

  public getTopPodcasts(page: number): Observable<Stream[]> {

    return this.httpClient.post<object>((`${this.apiURL}/topPodcasts`), {
      'page': page
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resPodcasts: Array<object> = JSON.parse(res['params']).podcasts;

      resPodcasts.forEach((item: object) => {
          result.push(Stream.fromPodcastResponseData(item));
      });

      return result;
    }));
  }

  public getTopPodcastsByGenre(genreId: number, page: number): Observable<Stream[]> {

    return this.httpClient.post<object>((`${this.apiURL}/topPodcastsByGenre`), {
      'genreId': genreId,
      'page': page
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resPodcasts: Array<object> = JSON.parse(res['params']).podcasts;

      resPodcasts.forEach((item: object) => {
          result.push(Stream.fromPodcastResponseData(item));
      });

      return result;
    }));
  }

  public getTopPodcastsByCountry(region: string, page: number): Observable<Stream[]> {

    return this.httpClient.post<object>((`${this.apiURL}/topPodcastsByCountry`), {
      'region': region,
      'page': page
    }).pipe(map(res => {
      const result = new Array<Stream>();

      const resPodcasts: Array<object> = JSON.parse(res['params']).podcasts;

      resPodcasts.forEach((item: object) => {
          result.push(Stream.fromPodcastResponseData(item));
      });

      return result;
    }));
  }

  public getPodcastsByName(search: string, offset: number): Observable<PodcastSearchResult> {

    return this.httpClient.post<object>((`${this.apiURL}/searchPodcasts`), {
      'term': search,
      'offset': offset
    }).pipe(map(res => {
      const resEpisodes: Array<object> = JSON.parse(res['params']);

      const podcastSearchResult = new PodcastSearchResult();
      podcastSearchResult.count = resEpisodes['count'];
      podcastSearchResult.nextOffset = resEpisodes['next_offset'];
      podcastSearchResult.total = resEpisodes['total'];

      podcastSearchResult.results = new Array();

      resEpisodes['results'].forEach((item: object) => {
          //const podcast = Podcast.fromResponseData(item);

          /*const podcast = new Podcast();
          podcast.id = item['podcast_id'];
          podcast.title = item['podcast_title_original'];

          episode.podcast = podcast;

          episodes.push(episode);*/
          podcastSearchResult.results.push(Stream.fromPodcastResponseData(item));
      });

      //podcastSearchResult.results = episodes;

      return podcastSearchResult;
    }));
  }

  public getPodcast(podcastId: string, nextEpisodePubDate: number): Observable<Podcast> {

    return this.httpClient.post<object>((`${this.apiURL}/podcast`), {
      podcastId,
      nextEpisodePubDate
    }).pipe(map(res => {

      const resPodcast: Array<object> = JSON.parse(res['params']);

      return Podcast.fromResponseData(resPodcast);
    }));
  }

  public getRecommendedPodcasts(podcastId: string): Observable<Podcast[]> {

    return this.httpClient.post<object>((`${this.apiURL}/recommendedPodcasts`), {
      podcastId
    }).pipe(map(res => {
      const result = new Array<Podcast>();

      const resPodcasts: Array<object> = JSON.parse(res['params']).recommendations;

      resPodcasts.forEach((item: object) => {
          result.push(Podcast.fromResponseData(item));
      });

      return result;
    }));
  }
}
